import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d44312c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "gateway",
  oncontextmenu: "return false",
  style: {"user-select":"none"}
}
const _hoisted_2 = { class: "gateway" }

import Crumb from '@/components/Crumb.vue';
import emitter from '@/utils/mitt';
import { defineAsyncComponent, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const StoreHouse = defineAsyncComponent(() => import('./Storehouse.vue'));
const Visualization = defineAsyncComponent(() => import('./Visualization.vue'));
const Custom = defineAsyncComponent(() => import('./Custom.vue'));

const visualization = ref();
const getVisualization = () => {
  emitter.emit('storehouse', { visualizationList: visualization.value.visualizationList });
};
// 添加模块重排
const resetModule = () => {
  emitter.emit('resetModule', false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(StoreHouse), { onGetVisualization: getVisualization }),
      _createElementVNode("div", {
        class: "gateway_visualization",
        onClick: resetModule
      }, [
        _createVNode(_unref(Visualization), {
          ref_key: "visualization",
          ref: visualization
        }, null, 512)
      ]),
      _createVNode(_unref(Custom))
    ])
  ]))
}
}

})